import React from 'react';
import { Space, Typography, Button } from 'antd';
import { useTranslation } from 'react-i18next';

const { Paragraph, Text } = Typography;

export default function SetupEnd({ onDone }) {
  const { t } = useTranslation();
  return (
    <Paragraph className="setup-end">
      <Space direction="vertical" size="middle">
        <Text className="setup-end__desc">{t('setup-end-desc-top')}</Text>
        <div className="setup-end__action">
          <Button type="primary" size="large" onClick={onDone}>
            {t('setup-end-button')}
          </Button>
        </div>
        <Text className="setup-end__subdesc">{t('setup-end-desc-bottom')}</Text>
      </Space>
    </Paragraph>
  );
}
